'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddController = function () {
  function AddController(CouponsDataProvider, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, AddController);
    this.CouponsDataProvider = CouponsDataProvider;
    this.$state = $state;
    var vm = this;
    vm.couponTypes = [{ 'id': 1, 'name': 'Percentage' }, { 'id': 2, 'name': 'Flat' }];
    vm.CouponsDataProvider.getCoupon(vm.$state.params.id).then(function (result) {
      vm.coupon = result;
    });
  }

  (0, _createClass3.default)(AddController, [{
    key: 'update',
    value: function update(form) {
      if (!form) {
        return false;
      }
      var vm = this;
      vm.CouponsDataProvider.updateCoupon(vm.coupon, vm.coupon.id).then(function (res) {
        if (res.exist == '1') {
          vm.existRecord = 1;
        } else {
          vm.$state.go('app.couponlisting');
        }
      });
    }
  }]);
  return AddController;
}();

// WEBPACK FOOTER //


exports.default = AddController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/coupons/components/edit/controller.js
 **/